import { render } from "./NotificationHistory.vue?vue&type=template&id=6323abb6&scoped=true"
import script from "./NotificationHistory.vue?vue&type=script&lang=js"
export * from "./NotificationHistory.vue?vue&type=script&lang=js"

import "./NotificationHistory.vue?vue&type=style&index=0&id=6323abb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6323abb6"]])

export default __exports__